"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcAccessToken = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _OidcToken = require("./OidcToken");
class OidcAccessToken extends _OidcToken.OidcToken {
  constructor(token) {
    super(typeof token === 'string' ? token.replace(/^Bearer /, '') : token);
    (0, _defineProperty2.default)(this, "toString", () => `Bearer ${this.token}`);
  }
}
exports.OidcAccessToken = OidcAccessToken;
//# sourceMappingURL=OidcAccessToken.js.map